import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ChatSupportBtn from "./ChatSupportBtn";
import moment from "moment";
// import Tabs, { Tab } from "react-best-tabs";
// import "react-best-tabs/dist/index.css";
import { logout } from "./Utility";
import { Tooltip } from "antd";
import customFetch from "../components/apicall/api";
import Cookies from "js-cookie";
import { PESelect } from "./permissionComponents";
import styles from "../assets/css/NACHHousehold_list.module.css";
function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

let api_token = "";
let hh_no = "";

const NACH_Household_list = () => {
  const history = useHistory();
  const location = useLocation();

  const [api_t, setApi_t] = useState("");
  const [datafordis, setDatafordis] = useState("");
  const [searchid, setSearchid] = useState("");
  const [searchdate, setSearchdate] = useState("");
  const [searchstatus, setSearchstatus] = useState("");
  const [searchtype, setSearchtype] = useState("");
  const [isSpin, setIsSpin] = useState(false);
  const [cnames, setCnames] = useState([]);
  const [isCreateuser, setIsCreateuser] = useState(false);
  const [nachtyp, setNachtyp] = useState("");
  const [collection_ac, setCollection_ac] = useState("");
  const [partnerpayment, setPartnerpayment] = useState([]);
  const [partnerpaymentfiltered, setPartnerpaymentfiltered] = useState([]);
  const [multipartnerpayment, setMultipartnerpayment] = useState([]);
  const [pgdata, setPgdata] = useState([]);
  const [productdata, setProductdata] = useState(null);
  const [hhid, setHhid] = useState("");
  const [acno, setAcno] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [hhnoState, setHhnoState] = useState("");
  const [name_as_per_account, setName_as_per_account] = useState("");
  const [account_type_name, setAccount_type_name] = useState("");
  const [loan_id, setLoan_id] = useState("");
  const [bank_name, setBank_name] = useState("");
  const [isNACHMessage, setIsNACHMessage] = useState("");
  const [isNACH, setIsNACH] = useState(false);
  const [time_start, setTime_start] = useState("");
  const [isView, setIsView] = useState("");
  const [viewFile, setViewFile] = useState("");
  const [isConfirmdisable, setIsConfirmdisable] = useState(false);
  const [isTokenDel, setIsTokenDel] = useState(false);
  const [isOrderid, setIsOrderid] = useState(false);
  const [physical_nach_order_id, setPhysical_nach_order_id] = useState("");
  const [nach_status_type_flag, setNach_status_type_flag] = useState("");
  const [nach_type, setNach_type] = useState("");
  const [NACH_form_upload, setNACH_form_upload] = useState("");
  const [ISNACH_form_upload, setISNACH_form_upload] = useState(false);
  const [cpn, setCpn] = useState(0);
  const [showSearch, setShowSearch] = useState(false);
  const [SMSemailSuccess, setSMSemailSuccess] = useState("");
  const [isSMSemail, setIsSMSemail] = useState(false);
  const [nach_partner_id, setNach_partner_id] = useState("");
  const [user_id, setUser_id] = useState("");
  const [nach_status, setNach_status] = useState([]);
  const [nach_history, setNach_history] = useState([]);
  const [temp_loan_id, setTemp_loan_id] = useState("");
  const [otherScreen, setOtherScreen] = useState("");
  const [bankNachData, setBankNachData] = useState([]);
  const [isAndroid, setIsAndroid] = useState(false);
  const [disableBTN, setDisableBTN] = useState(true);
  const [productlist, setProductlist] = useState([]);
  const [product_id, setProduct_id] = useState(null);
  const [allowedNachTypes, setAllowedNachTypes] = useState([]);
  const [effectiveDesignationId, setEffectiveDesignationId] = useState("");
  const [isErrOpen, setIsErrOpen] = useState(false);
  const [api_error_message, setApi_error_message] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [errMsg, setErrMsg] = useState("");
  const [nachpartner, setNachpartner] = useState([]);
  const [isHistory, setIsHistory] = useState(false);
  const [bank_id, setBank_id] = useState("");
  const [aadhaarNo, setAadhaarNo] = useState(""); // New state for Aadhaar number
  const [vpaId, setVpaId] = useState(""); // New state for VPA ID
  const [showAadhaarFields, setShowAadhaarFields] = useState(false); // New state to show/hide Aadhaar fields

  // For dynamic upload input refs like this["upload" + bank_id]
  const uploadRefs = useRef({});

  //  AT-2110 | Vaibhav Sawant | 06-07-2023 | Functionality to allow to Expire Physical NACH for FIN-OPS
  const markExpire = (bank_id, order_id) => {
    setIsSpin(true);

    const formdata = new FormData();
    formdata.append("bank_id", bank_id);
    formdata.append("order_id", order_id);

    customFetch(process.env.REACT_APP_URL + "/mark/nach/expire", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsNACH(true);
          setIsNACHMessage(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        setIsNACH(true);
        setIsNACHMessage(json.message);
        setIsSpin(false);
      })
      .catch((error) => console.log("error", error));
  };

  // AT-2461 | Vaibhav Sawant | 31-10-2023 | Button added to clear cache for particular household_number
  const clearCache = (household_number) => {
    setIsSpin(true);

    const formdata = new FormData();
    formdata.append(
      "multiple_keys",
      '(get_nach_registration_history:{"household_number": "' +
        household_number +
        '"},get_household_list:{"household_number": "' +
        household_number +
        '"})'
    );

    customFetch(process.env.REACT_APP_URL + "/clear/cache", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsNACH(true);
          setIsNACHMessage(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          history.push("/");
        }
        setIsNACH(true);
        setIsNACHMessage(json.message);
        setIsSpin(false);
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    // componentDidMount
    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      setIsAndroid(true);
      const data = window.Android.getDataFromLocalStorage("your_key");
      if (data) {
        setIsSpin(false);
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });
        localStorage.setItem("api_token", tokenData.access_token);
      }
    } else {
      console.log(
        "Error in AndroidInterface: Android method not found or not available."
      );
    }
    
    // Set effective designation ID from props or localStorage
    const effectiveIdFromProps = 
      (location && location.state && location.state.effective_designation_id) || 
      localStorage.getItem("e_designation_id") || 
      "";
    
    console.log("Setting effectiveDesignationId:", effectiveIdFromProps);
    setEffectiveDesignationId(effectiveIdFromProps);
    
    checkForRequest();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Trigger fetchDetails after searchid and datafordis state updates complete
  useEffect(() => {
    if (searchid && datafordis === "hhid" && otherScreen === 1) {
      fetchDetails();
    }
  }, [searchid, datafordis, otherScreen]); // eslint-disable-line react-hooks/exhaustive-deps

  const getnachstatuslist = () => {
    setIsSpin(true);
    setTime_start(moment());

    customFetch(process.env.REACT_APP_URL + "/get/nach/status/type/details", {
      method: "GET",
      headers: { "api-token": api_token },
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsErrOpen(true);
          setApi_error_message(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        setNach_status(json);
        setIsSpin(false);
      })
      .catch((error) => console.log("error", error));
  };

  const checkForRequest = () => {
    const search = location.search;
    const params = new URLSearchParams(search);

    // FIRST: try URL params
    api_token = params.get("api_token");
    hh_no = params.get("lead_id");

    // SECOND: fallback to navigation state (NO OPTIONAL CHAINING)
    if (!api_token) {
      api_token =
        (location && location.state && location.state.api_token) ||
        localStorage.getItem("api_token");
    }

    if (!hh_no) {
      hh_no =
        (location &&
          location.state &&
          (location.state.hh_number || location.state.lead_id)) ||
        params.get("lead_id");
    }

    // store locally
    if (api_token) localStorage.setItem("api_token", api_token);
    if (hh_no) {
      setSearchid(hh_no);
      setDatafordis("hhid"); // Set datafordis so fetchDetails uses household_number
    }

    // Validate we have user_id
    let uid =
      (location && location.state && location.state.u_id) ||
      localStorage.getItem("in_userid");

    if (!uid) {
      history.goBack();
      return;
    }
    setUser_id(uid);
    localStorage.setItem("in_userid", uid);

    // FINAL: we have everything → now fire APIs
    setShowSearch(false);
    setOtherScreen(1);

    // fetchDetails will be called by useEffect after state updates
    getnachstatuslist();
    getnachpartner();
  };

  const getUniqueNachTypes = (data) => {
    const uniqueNachMap = new Map();
    const allGateways = data.flatMap(
      (partner) => partner.payment_gateway || []
    );
    const allNachObjects = allGateways.flatMap(
      (gateway) => gateway.allowed_nach_types || []
    );

    allNachObjects.forEach((nachObject) => {
      const typeName = Object.keys(nachObject)[0];
      uniqueNachMap.set(typeName, nachObject);
    });
    const uniqueNachTypes = Array.from(uniqueNachMap.values());
    return uniqueNachTypes;
  };

  const filterPartnersByNachType = (data, requiredNachType) => {
    const filteredPartners = data
      .map((partner) => {
        const filteredGateways = (partner.payment_gateway || []).filter(
          (gateway) => {
            const isAllowed = (gateway.allowed_nach_types || []).some(
              (nachTypeObject) => {
                return Object.values(nachTypeObject).includes(requiredNachType);
              }
            );
            return isAllowed;
          }
        );
        return {
          ...partner,
          payment_gateway: filteredGateways,
        };
      })
      .filter((partner) => partner.payment_gateway.length > 0);

    return filteredPartners;
  };

  const getproductlist = (household_no) => {
    setIsSpin(true);
    customFetch(
      process.env.REACT_APP_URL +
        "/get/household/product-partners?household_number=" +
        household_no,
      {
        method: "GET",
        headers: { "api-token": api_token },
      }
    )
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsErrOpen(true);
          setApi_error_message(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        let _allowedNachTypes = getUniqueNachTypes(json);
        _allowedNachTypes = _allowedNachTypes.sort((a, b) => {
          const keyA = Object.keys(a)[0];
          const keyB = Object.keys(b)[0];
          return keyA.localeCompare(keyB);
        });

        setPartnerpayment(json);
        setAllowedNachTypes(_allowedNachTypes);
        setNachtyp(""); // Keep empty by default - user must select
        setPgdata([]);
        setIsSpin(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsSpin(false);
      });
  };

  const getnachpartner = () => {
    setIsSpin(true);
    customFetch(process.env.REACT_APP_URL + "/get/nach/partner/list", {
      method: "GET",
      headers: { "api-token": api_token },
    })
      .then((res) => res.json())
      .then((json) => {
        setNachpartner(json);
        setIsSpin(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsSpin(false);
      });
  };

  const setCookieData = (productId, productList) => {
    const currentData = Cookies.get("nachProductPartnerMap");
    let data = currentData ? JSON.parse(currentData) : {};

    data[productId] = {
      product_list: productList,
      expiry: new Date().getTime() + 3600 * 24000 * 7,
    };
    Cookies.set("nachProductPartnerMap", JSON.stringify(data), { expires: 7 });
  };

  const getCookieData = (productId) => {
    const cookieData = Cookies.get("nachProductPartnerMap");
    if (cookieData) {
      const data = JSON.parse(cookieData);
      const currentTime = new Date().getTime();
      if (data[productId] && currentTime <= data[productId].expiry) {
        return data[productId].product_list;
      }
    }
    return null;
  };

  const fetchDetails = () => {
    setIsSpin(true);
    setTime_start(moment());
    setCnames([]);

    let queryparam = "?";
    if (searchid != null && searchid !== "") {
      if (datafordis === "loanid") {
        queryparam += "loan_id=" + searchid + "&";
      }
      if (datafordis === "hhid") {
        queryparam += "household_number=" + searchid + "&";
      }
    }
    if (searchdate != null && searchdate !== "") {
      queryparam += "ageing=" + searchdate + "&";
    }
    if (searchstatus != null && searchstatus !== "") {
      queryparam += "nach_status_type_flag=" + searchstatus + "&";
    }
    if (searchtype != null && searchtype !== "") {
      queryparam += "nach_type=" + searchtype;
    }

    customFetch(process.env.REACT_APP_URL + "/get/householdlist" + queryparam, {
      method: "GET",
      headers: { "api-token": api_token },
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsErrOpen(true);
          setApi_error_message(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        let unique = json.filter(
          (j, index, self) =>
            index === self.findIndex((t) => t.bank_id === j.bank_id)
        );

        setCnames(unique);

        let bankNachArray = [];
        unique.forEach((item) => {
          bankNachArray.push({
            bank_id: item.bank_id,
            nach_data: [],
          });
        });

        const params = {
          household_number: searchid,
        };
        const queryParams = new URLSearchParams(params).toString();

        customFetch(
          process.env.REACT_APP_URL +
            "/get/nach/registration/history?" +
            queryParams,
          {
            method: "GET",
            headers: { "api-token": api_token },
          }
        )
          .then((res) => res.json())
          .then((json2) => {
            json2.forEach((item) => {
              bankNachArray.forEach((nitem) => {
                if (nitem.bank_id === item.bank_id) {
                  nitem.nach_data.push(item);
                }
              });
            });

            setIsSpin(false);
            setNach_history(json2);
            setBankNachData(bankNachArray);
          })
          .catch((error) => console.log("error", error));
      })
      .catch((error) => console.log("error", error));
  };

  const showNACHPopup = (item) => {
    if (item.bank_status === "A") {
      let fData =
        bankNachData && bankNachData.length > 0
          ? bankNachData
              .filter(
                (itemdata) =>
                  itemdata.bank_id === item.bank_id &&
                  itemdata.nach_data !== null
              )
              .flatMap((filteritem) => filteritem.nach_data)
              .filter(
                (nach) =>
                  nach.nach_status_type_flag !== "E" &&
                  nach.nach_status_type_flag !== "J"
              )
              .map((nach) => ({
                nach_type: nach.nach_type,
                partner_vendor_payment_account_id:
                  nach.partner_vendor_payment_account_id,
                nach_flag: nach.nach_status_type_flag,
              }))
          : [];

      setFilteredData(fData);
      setIsCreateuser(true);
      setHhid(item.household_id);
      setAcno(item.account_number);
      setIfsc(item.ifsc);
      setHhnoState(item.household_number);
      setName_as_per_account(item.name_as_per_account);
      setAccount_type_name(item.account_type_name);
      setBank_name(item.bank_name);
      setBank_id(item.bank_id); 
      setNach_status_type_flag(item.nach_status_type_flag);
      setNach_partner_id(item.nach_partner_id || "");
      setProductdata(null);
      setPartnerpayment([]);
      setPartnerpaymentfiltered([]);
      setPgdata([]);
      setProductlist([]);
      setProduct_id(null);
      setIsNACH(false);
      setNachtyp("");
      setErrMsg("");
      setDisableBTN(true);
      setCollection_ac("");
      setAadhaarNo(""); // Reset Aadhaar number
      setVpaId(""); // Reset VPA ID
      setShowAadhaarFields(false); // Reset Aadhaar fields visibility

      getproductlist(item.household_number);
    } else {
      setIsNACH(true);
      setIsNACHMessage("Bank Account is not Approved!");
    }
  };

  const getpg = (selectedPartnerId) => {
    console.log("getpg called with partnerId:", selectedPartnerId);
    console.log("partnerpaymentfiltered:", partnerpaymentfiltered);
    
    let newPgData = [];

    // Convert selectedPartnerId to number for comparison
    const partnerIdNum = Number(selectedPartnerId);

    // Find the selected partner in the filtered list
    const selectedPartner = partnerpaymentfiltered.find(
      (partner) => partner.partner_id === partnerIdNum
    );

    console.log("selectedPartner:", selectedPartner);

    if (selectedPartner && selectedPartner.payment_gateway) {
      newPgData = selectedPartner.payment_gateway;
      console.log("Payment gateways for this partner:", newPgData);
    } else {
      console.log("No payment gateways found for this partner");
    }

    setPgdata(newPgData);
    setCollection_ac(""); // Reset gateway selection when partner changes
  };

  const handleNachTypeChange = (e) => {
    const v = e.target.value;
    console.log("NACH Type changed to:", v);
    console.log("Current partnerpayment:", partnerpayment);
    
    setNachtyp(v);
    setPgdata([]);
    setProductdata(null);
    setCollection_ac("");
    setAadhaarNo(""); // Reset Aadhaar number
    setVpaId(""); // Reset VPA ID
    
    // Aadhaar fields are not needed - NPCI collects Aadhaar directly
    setShowAadhaarFields(false);

    if (partnerpayment && partnerpayment.length > 0) {
      const filtered = filterPartnersByNachType(partnerpayment, v);
      console.log("Filtered partners for NACH type:", filtered);
      setPartnerpaymentfiltered(filtered);
    } else {
      console.log("partnerpayment is empty or undefined");
    }
  };

  const handlePartnerChange = (selectedPartnerId) => {
    console.log("Partner changed to:", selectedPartnerId);
    
    if (!selectedPartnerId || selectedPartnerId === "") {
      setProductdata(null);
      setPgdata([]);
      setCollection_ac("");
      return;
    }

    setProductdata(selectedPartnerId);
    setCollection_ac(""); // Reset gateway selection when partner changes

    // Call getpg with the selected partner ID
    getpg(selectedPartnerId);
  };

  const handleCollectionAcChange = (e) => {
    const v = e.target.value;
    console.log("Collection AC changed to:", v);
    setCollection_ac(v);
  };

  const handleAadhaarChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Allow only numbers
    setAadhaarNo(value);
  };

  const handleVpaChange = (e) => {
    setVpaId(e.target.value);
  };

  const dynamicFormSubmit = (url, method, formItems, target = "_blank") => {
    const form = document.createElement("form");

    form.action = url;
    form.method = method.toLowerCase();
    form.target = target;
    form.style.display = "none";

    for (const name in formItems) {
      if (Object.prototype.hasOwnProperty.call(formItems, name)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = String(formItems[name]);
        form.appendChild(input);
      }
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    console.log(`Form submitted to: ${url} with method: ${method}`);
  };

  const setNACHHousehold = () => {
    console.log("=== REGISTER CLICKED ===");
    console.log("bank_id:", bank_id);
    console.log("collection_ac:", collection_ac);
    console.log("nachtyp:", nachtyp);
    console.log("hhid:", hhid);
    console.log("hhnoState:", hhnoState);
    console.log("user_id:", user_id);
    console.log("aadhaarNo:", aadhaarNo);
    console.log("vpaId:", vpaId);
    
    setIsSpin(true);

    if (user_id === "" || user_id == null || user_id === "null") {
      history.goBack();
      return;
    }

    const formdata = new FormData();
    formdata.append("user_id", user_id);
    formdata.append("bank_id", bank_id);
    formdata.append("map_id", collection_ac.split("~")[1]);
    formdata.append("bank_acc_no", acno);
    formdata.append("nach_type", nachtyp);
    formdata.append("ifsc_code", ifsc);
    formdata.append("beneficiary_name", name_as_per_account);

    let tmp_acc_type = "";
    if (account_type_name === "Savings" || account_type_name === "Jan-Dhan") {
      tmp_acc_type = "savings";
    } else if (account_type_name === "Current") {
      tmp_acc_type = "current";
    }
    formdata.append("acc_type", tmp_acc_type);
    formdata.append("hhno", hhnoState);
    formdata.append("hhid", hhid);

    // Aadhaar is collected directly by NPCI - not required on frontend

    customFetch(process.env.REACT_APP_URL + "/set/nach/household/bank", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => res.json())
      .then((json) => {
        setIsSpin(false);

        if (json.action === "REDIRECT") {
          dynamicFormSubmit(
            process.env.REACT_APP_URL + json.data.endpoint,
            json.data.method,
            json.data.form_items,
            "_blank"
          );
        }

        let nach_message = "";
        if (json.status === 1) {
          nach_message = json.order_id
            ? "Order ID: " + json.order_id + ", created!"
            : json.message;
        } else {
          nach_message = json.message;
        }

        setIsNACH(true);
        setIsNACHMessage(nach_message);
        setIsCreateuser(false);
      })
      .catch((error) => console.log("error", error));
  };

  const updata = () => {
    fetchDetails();
  };

  const viewclick = (path) => {
    setIsSpin(true);
    setTime_start(moment());

    if (path) {
      if (path.includes("Uploaded")) {
        setIsNACHMessage(path);
        setIsNACH(true);
        setIsSpin(false);
      } else {
        const formdata = new FormData();
        formdata.append("blob_url", path);
        const requestOptions = {
          method: "POST",
          headers: {
            "api-token": api_token,
          },
          body: formdata,
        };
        customFetch(
          process.env.REACT_APP_URL + "/get/public/url",
          requestOptions
        )
          .then((res) => {
            if (res.headers.get("api_code") > 0) {
              setIsErrOpen(true);
              setApi_error_message(res.headers.get("api_error_message"));
              setIsSpin(false);
            }
            return res.json();
          })
          .then((img) => {
            setViewFile(img.public_url);
            setIsView(true);
            setIsSpin(false);
          })
          .catch((error) => console.log("error", error));
      }
    } else {
      setViewFile("");
      setIsView(true);
      setIsSpin(false);
    }
  };

  const deleteToken = (tid) => {
    setIsConfirmdisable(true);
    setIsSpin(true);
    setTime_start(moment());

    const formdata = new FormData();
    formdata.append("nach_token_id", tid);
    customFetch(process.env.REACT_APP_URL + "/deletetokenhousehold", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsErrOpen(true);
          setApi_error_message(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        setIsNACH(true);
        setIsNACHMessage(json.message);
        setIsSpin(false);
        setCpn(0);
      })
      .catch((error) => console.log("error", error));
  };

  const ImgchangeHandler = (event, bank_id, nach_order_id, map_id) => {
    setIsSpin(true);
    setTime_start(moment());
    event.stopPropagation();

    const file = event.target.files[0];
    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("order_id", nach_order_id);
    formdata.append("bank_id", bank_id);
    formdata.append("map_id", map_id);

    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token,
      },
      body: formdata,
    };
    customFetch(process.env.REACT_APP_URL + "/upload/nach/form", requestOptions)
      .then((response) => {
        if (response.headers.get("api_code") > 0) {
          setIsNACH(true);
          setIsNACHMessage(response.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return response.json();
      })
      .then((data) => {
        setNACH_form_upload(data);
        setISNACH_form_upload(true);
        setIsSpin(false);
      })
      .catch((error) => console.log("error", error));
  };

  const clearPhysicalNACH = (bank_id) => {
    setIsSpin(true);
    setTime_start(moment());

    const formdata = new FormData();
    formdata.append("bank_id", bank_id);

    customFetch(process.env.REACT_APP_URL + "/clearPhysicalNACH", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          setIsNACH(true);
          setIsNACHMessage(res.headers.get("api_error_message"));
          setIsSpin(false);
        }
        return res.json();
      })
      .then((json) => {
        setIsNACH(true);
        setIsNACHMessage(json.message);
        setIsSpin(false);
        setCpn(0);
      })
      .catch((error) => console.log("error", error));
  };

  const sendsmsmail = (orderid, mapid, sendtype) => {
    setIsSpin(true);
    setTime_start(moment());
    const formdata = new FormData();
    formdata.append("inv_id", orderid);
    formdata.append("medium", sendtype);
    formdata.append("partner_vendor_payment_account_id", mapid);

    customFetch(process.env.REACT_APP_URL + "/send/notification", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => res.json())
      .then((json) => {
        const successMessage = json.order_id 
          ? `${json.message}\nOrder ID: ${json.order_id}` 
          : json.message;
        setSMSemailSuccess(successMessage);
        setIsSMSemail(true);
        setIsSpin(false);
      })
      .catch((error) => console.log("error", error));
  };

  const showNACHhistory = (hhnumber, loan_id_val) => {
    setIsSpin(true);
    setTemp_loan_id(loan_id_val);

    const params = {
      household_number: hhnumber,
    };
    const queryParams = new URLSearchParams(params).toString();

    customFetch(
      process.env.REACT_APP_URL +
        "/get/nach/registration/history?" +
        queryParams,
      {
        method: "GET",
        headers: { "api-token": api_token },
      }
    )
      .then((res) => res.json())
      .then((json) => {
        setIsSpin(false);
        setNach_history(json);
        setIsHistory(true);
      })
      .catch((error) => console.log("error", error));
  };

  const downloadfile = (url) => {
    if (window.Android && typeof window.Android.postMessage === "function") {
      window.Android.postMessage(url);
      setIsView(false);
    } else {
      console.error(
        "window.Android.postMessage is not a function or is not available."
      );
    }
    const filename = url.split("/").pop();
    customFetch(url, {
      headers: { "api-token": api_token },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const urlBlob = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  const chkreqdata = () => {
    if (nachtyp !== "" && collection_ac !== "") {
      setDisableBTN(false);
    } else {
      setDisableBTN(true);
    }
  };

  const chkregisterdata = () => {
    console.log("Checking conditions...");
    console.log("nachtyp:", nachtyp);
    console.log("collection_ac:", collection_ac);
    console.log("productdata:", productdata);
    console.log("pgdata length:", pgdata.length);

    if (!nachtyp || nachtyp === "") {
      console.log("Missing NACH Type → Disable");
      setDisableBTN(true);
      return;
    }

    // Aadhaar number is now optional - collected directly by NPCI
    setErrMsg("");

    if (!collection_ac || collection_ac === "") {
      console.log("Missing collection_ac → Disable");
      setDisableBTN(true);
      return;
    }

    // If no filteredData, allow registration
    if (!filteredData || filteredData.length === 0) {
      console.log("No existing NACH entry → Enable");
      setDisableBTN(false);
      setErrMsg("");
      return;
    }

    // Check if NACH already registered with same partner gateway
    const selectedMapId = collection_ac.split("~")[1];
    console.log("Checking for duplicate NACH...");
    console.log("Selected map_id:", selectedMapId);
    console.log("filteredData:", filteredData);
    
    const alreadyPresent = filteredData.some(
      (fdata) => {
        console.log("Comparing:", {
          nach_flag: fdata.nach_flag,
          stored_map_id: fdata.partner_vendor_payment_account_id,
          selected_map_id: selectedMapId,
          match: fdata.nach_flag === "R" && String(fdata.partner_vendor_payment_account_id) === String(selectedMapId)
        });
        return (
          fdata.nach_flag === "R" &&
          String(fdata.partner_vendor_payment_account_id) === String(selectedMapId)
        );
      }
    );

    if (alreadyPresent) {
      console.log("Already Registered → Disable");
      setDisableBTN(true);
      setErrMsg("NACH Already Present for this Partner");
    } else {
      console.log("Valid → Enable");
      setDisableBTN(false);
      setErrMsg("");
    }
  };

  useEffect(() => {
    chkregisterdata();
  }, [nachtyp, collection_ac, filteredData]);

  useEffect(() => {
    if (nachtyp && partnerpayment.length > 0) {
      const filtered = filterPartnersByNachType(partnerpayment, nachtyp);
      console.log("Auto-filtered partners for NACH type:", filtered);
      setPartnerpaymentfiltered(filtered);
    }
  }, [nachtyp, partnerpayment]);

  // Just to keep existing form onChange, though it does nothing special
  const handleFormChange = () => {};

  return (
    <>
      {isSpin ? (
        <div className={styles.preloader}>
          <div className={styles.loader} ng-hide="data.length > 0"></div>
        </div>
      ) : (
        ""
      )}

      {/* History Modal */}
      <div
        className={
          isHistory
            ? `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']} ${styles.show} ${styles.mymodal}`
            : `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']}`
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className={`${styles['modal-dialog']} ${styles['modal-lg']}`}>
          <div className={`${styles['modal-content']} ${styles['cdb-confirm-box']}`}>
            <button
              type="button"
              className={`${styles.close} ${styles['text-right']}`}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setIsHistory(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div className={styles['table-responsive']}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>Bank Account</th>
                    <th>NACH Type</th>
                    <th>NACH Status</th>
                    <th>Vendor</th>
                    <th>Date</th>
                    <th>Operations</th>
                  </tr>
                </thead>
                <tbody>
                  {nach_history &&
                    nach_history.map((historyItem, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{historyItem.bank_account_number}</td>
                          <td>{historyItem.nach_type_description}</td>
                          <td>{historyItem.nach_status_type_description}</td>
                          <td>
                            {historyItem.payment_vendor_name[0]} |{" "}
                            {historyItem.partner_code}
                          </td>
                          <td>{historyItem.added_at}</td>
                          <td>
                            {historyItem.nach_status_type_flag === "E" ||
                            historyItem.nach_status_type_flag === "J" ||
                            historyItem.nach_status_type_flag === "D" ||
                            historyItem.nach_status_type_flag === "R" ? (
                              "NA"
                            ) : historyItem.nach_type === "P" ? (
                              historyItem.signed_filename == null ||
                              historyItem.signed_filename === "null" ||
                              historyItem.signed_filename === "" ? (
                                <>
                                  <div className={styles.updownimg}>
                                    <img
                                      src={require("../assets/images/view-fin.png")}
                                      style={{width:"36px", height:"36px"}}
                                      className={styles['add-new']}
                                      onClick={() => {
                                        viewclick(historyItem.filename);
                                      }}
                                      alt="View Document"
                                    />

                                    <div
                                      className={styles['upload-img']}
                                      onClick={(event) => {
                                        event.preventDefault();
                                        const ref =
                                          uploadRefs.current[
                                            "upload" + temp_loan_id
                                          ];
                                        if (ref) ref.click();
                                      }}
                                    >
                                      <img
                                        src={require("../assets/images/upload.png")}
                                        style={{width:"36px", height:"36px"}}
                                        className={styles['add-new']}
                                        alt="Upload File"
                                      />
                                    </div>
                                    <input
                                      type="file"
                                      name="file"
                                      accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
                                      onChange={(event) => {
                                        event.preventDefault();
                                        setIsSpin(false);
                                        ImgchangeHandler(
                                          event,
                                          historyItem.bank_id,
                                          historyItem.physical_nach_order_id,
                                          historyItem.partner_vendor_payment_account_id
                                        );
                                      }}
                                      ref={(ref) => {
                                        uploadRefs.current[
                                          "upload" + temp_loan_id
                                        ] = ref;
                                      }}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className={styles.updownimg}>
                                    <img
                                      src={require("../assets/images/view-fin.png")}
                                      className={styles['add-new']}
                                      onClick={() => {
                                        viewclick(historyItem.signed_filename);
                                      }}
                                      alt="View Signed Document"
                                    />
                                  </div>
                                </>
                              )
                            ) : (
                              "NA"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* SMS/Email Modal */}
      <div
        className={
          isSMSemail
            ? `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']} ${styles.show} ${styles.mymodal}`
            : `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']}`
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className={`${styles['modal-dialog']} ${styles['modal-lg']}`}>
          <div className={`${styles['modal-content']} ${styles['cdb-confirm-box']} ${styles['col-sm-12']}`}>
            <button
              type="button"
              className={`${styles.close} ${styles['text-right']}`}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setIsSMSemail(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>{SMSemailSuccess}</p>
          </div>
        </div>
      </div>

      {/* Upload NACH Form Modal */}
      <div
        className={
          ISNACH_form_upload
            ? `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']} ${styles.show} ${styles.mymodal}`
            : `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']}`
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className={`${styles['modal-dialog']} ${styles['modal-lg']} ${styles['modal-dialog-centered']}`}>
          <div className={`${styles['modal-content']} ${styles.cdb_confirm_box} ${styles['col-sm-12']}`}>
            <button
              type="button"
              className={`${styles.close} ${styles['text-right']}`}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setISNACH_form_upload(false);
                updata();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>
              {NACH_form_upload ? (
                NACH_form_upload.razorpay_order_id ? (
                  <>
                    <strong>Order Id : </strong>
                    {NACH_form_upload.razorpay_order_id}
                    <br />
                    <strong>Payment Id : </strong>
                    {NACH_form_upload.razorpay_payment_id}
                    <br />
                  </>
                ) : (
                  <>
                    <span>{NACH_form_upload.message}</span>
                  </>
                )
              ) : (
                ""
              )}
            </p>
          </div>
        </div>
      </div>

      {/* View File Modal */}
      <div
        className={
          isView
            ? `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']} ${styles.show} ${styles.mymodal}`
            : `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']}`
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className={`${styles['modal-dialog']} ${styles['modal-lg']}`}>
          <div className={`${styles['modal-content']} ${styles['cdb-confirm-box']} ${styles['col-sm-12']}`}>
            <button
              type="button"
              className={`${styles.close} ${styles['text-right']}`}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsView(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>

            {viewFile ? (
              <>
                <iframe
                  className={styles.pdfviewfile}
                  src={
                    viewFile +
                    "#toolbar=1&navpanes=0&scrollbar=0&page=1&zoom=25"
                  }
                  title="NACH File"
                ></iframe>
                <div className={styles['popupdownload-btn']}>
                  <button
                    onClick={() => downloadfile(viewFile)}
                    className={`${styles.btn} ${styles['btn-primary']} ${styles.popupdownload}`}
                  >
                    Download
                  </button>
                </div>
              </>
            ) : (
              "File Not Found"
            )}
          </div>
        </div>
      </div>

      {/* Generic NACH Message Modal */}
      <div
        className={
          isNACH
            ? `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']} ${styles.show} ${styles.mymodal}`
            : `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']}`
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className={`${styles['modal-dialog']} ${styles['modal-lg']}`}>
          <div className={`${styles['modal-content']} ${styles['cdb-confirm-box']} ${styles['col-sm-12']}`}>
            <button
              type="button"
              className={`${styles.close} ${styles['text-right']}`}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setIsNACH(false);
                updata();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>{isNACHMessage}</p>
          </div>
        </div>
      </div>

      {/* Create User / Register NACH Modal */}
      <div
        className={
          isCreateuser
            ? `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']} ${styles.show} ${styles.mymodal}`
            : `${styles.modal} ${styles.fade} ${styles['bd-example-modal-sm']}`
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className={`${styles['modal-dialog']} ${styles['modal-lg']}`}>
          <div className={`${styles['modal-content']} ${styles['cdb-confirm-box']} ${styles['col-sm-12']}`}>
            <button
              type="button"
              className={`${styles.close} ${styles['text-right']}`}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsCreateuser(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <form onChange={handleFormChange}>
              <div className={styles['loanid-holder']}>
                <span>Loan ID : {loan_id}</span>
              </div>
              <div className={styles['loan-dataholder']}>
                <div>HH No : {hhnoState}</div>
                <div className={styles['loandata-border']}>Account No : {acno}</div>
                <div>
                  IFSC : {ifsc} ({bank_name})
                </div>
              </div>
              <div className={styles['selnach-holder']}>
                <div
                  className={styles.row}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div style={{ flex: 1 }}>
                      <select
                        value={nachtyp}
                        className={`${styles['form-control']} ${styles.selnach}`}
                        name="nachtyp"
                        onChange={handleNachTypeChange}
                      >
                        <option value="">Select NACH Type</option>
                        {allowedNachTypes.map((nachTypeItem, index) => {
                          const label = Object.keys(nachTypeItem)[0];
                          const value = nachTypeItem[label];
                          return (
                            <option key={index} value={value}>
                              {label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  
                  {/* Aadhaar Fields - Only show when Aadhaar is selected */}
                  {showAadhaarFields && (
                    <>
                      <div style={{ width: "100%" }}>
                        <div style={{ flex: 1 }}>
                          <input
                            type="text"
                            className={`${styles['form-control']} ${styles.selnach}`}
                            placeholder="Enter Aadhaar Number (12 digits)"
                            value={aadhaarNo}
                            onChange={handleAadhaarChange}
                            maxLength="12"
                          />
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        <div style={{ flex: 1 }}>
                          <input
                            type="text"
                            className={`${styles['form-control']} ${styles.selnach}`}
                            placeholder="Enter VPA ID (Optional)"
                            value={vpaId}
                            onChange={handleVpaChange}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  
                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <select
                        className={`${styles['form-control']} ${styles.selpartner}`}
                        value={productdata || ""}
                        onChange={(e) => {
                          console.log("Partner selected:", e.target.value);
                          handlePartnerChange(e.target.value);
                        }}
                      >
                        <option value="">Select Partner</option>
                        {partnerpaymentfiltered &&
                          partnerpaymentfiltered.length > 0 ? (
                          partnerpaymentfiltered.map((item) => (
                            <option
                              key={item.partner_id}
                              value={item.partner_id}
                            >
                              {item.partner_name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            {nachtyp
                              ? "No partners available for this NACH type"
                              : "Select a NACH type first"}
                          </option>
                        )}
                      </select>
                    </div>
                    <div style={{ flex: 1 }}>
                      <select
                        className={`${styles['form-control']} ${styles.selpartnergateway}`}
                        id="exampleFormControlSelect1"
                        name="collection_ac"
                        value={collection_ac}
                        onChange={handleCollectionAcChange}
                        disabled={pgdata.length === 0}
                      >
                        <option value="">Select Payment Gateway</option>
                        {pgdata && pgdata.length > 0 ? (
                          pgdata.map((pg, index) => (
                            <option
                              key={index}
                              value={pg.bank_account_number + "~" + pg.map_id}
                              title={pg.payment_vendor_name}
                            >
                              {pg.payment_vendor_name +
                                " - " +
                                pg.bank_account_number}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            {productdata
                              ? "No gateways available for this partner"
                              : "Select a partner first"}
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles['form-group']} ${styles['regbtn-holder']}`}>
              <button
                        className={disableBTN ? `${styles.regbtn} ${styles.regbtnopacity}` : styles.regbtn}
                        type="button"
                        disabled={disableBTN}
                        onClick={setNACHHousehold}
                      >
                        Register
              </button>
                {errMsg && <div className={styles['email-error']}>{errMsg}</div>}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* MAIN SECTION */}
      <section className={styles['main-sec']}>
        <div className={`${styles.container} ${styles['fix-width']}`}>
          <div className={styles['header-area']}>
            <div className={styles.icon_bg} onClick={() => history.goBack()}>
              <img
                src={require("../assets/images/back.png")}
                className={styles.cso_icon_img}
                alt="Back"
              />
            </div>
            <div className={styles['head-title']}>Search Household</div>
            {isAndroid ? (
              <></>
            ) : (
              <div className={styles['log-out-report']}>
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout(otherScreen)}
                  alt="Logout"
                />
              </div>
            )}
          </div>

          {showSearch ? (
            <div className={`${styles['search-holder']} ${styles['mt-3']}`}>
              <div className={`${styles.container} ${styles.row}`}>
                <div className={styles['col-2']}>
                  <input
                    className={styles['form-control']}
                    placeholder="Enter Household ID"
                    name="searchid"
                    onChange={(e) => {
                      setDatafordis("hhid");
                      setSearchid(e.target.value);
                    }}
                  />
                </div>
                <div className={styles['col-2']}>
                  <input
                    className={styles['form-control']}
                    type="date"
                    name="searchdate"
                    onChange={(e) => setSearchdate(e.target.value)}
                  />
                </div>
                <div className={styles['col-3']}>
                  <select
                    className={styles['form-control']}
                    name="searchstatus"
                    onChange={(e) => setSearchstatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    {nach_status.map((statusItem) => (
                      <option
                        key={statusItem.nach_status_type_flag}
                        value={statusItem.nach_status_type_flag}
                      >
                        {statusItem.nach_status_type_description}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles['col-3']}>
                  <select
                    className={styles['form-control']}
                    name="searchtype"
                    onChange={(e) => setSearchtype(e.target.value)}
                  >
                    <option value="">Select NACH Type</option>
                    <option value="P">Physical</option>
                    <option value="N">Net Banking</option>
                    <option value="D">Debit Card</option>
                    <option value="A">Aadhaar</option>
                  </select>
                </div>
                <div className={styles['col-1']}>
                  <Tooltip title="Search">
                    <img
                      src={require("../assets/images/searchicn.svg")}
                      className={styles['searchbtn-nach']}
                      onClick={() => fetchDetails()}
                      alt="Search"
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className={`${styles['form-group']} ${styles.row}`}></div>

          <div className={styles['mt-3']}>
            {cnames.length > 0
              ? cnames.map((item, index) => (
                  <div className={`${styles['card-holder']} ${styles['mt-3']}`} key={index}>
                    <div className={styles['card-name-holder']}>
                      <div className={styles.row}>
                        <div className={styles['col-4']}>
                          <div className={styles['card-name']}>{item.borrower}</div>
                          <div className={styles['card-hhid']}>
                            HH ID : {item.household_number}
                          </div>
                        </div>
                        <div className={styles['col-5']}>
                          <div className={styles['card-hhid']}>
                            Bank Name : {item.bank_name}
                          </div>
                          <div className={styles['card-hhid']}>
                            Account Number : {item.account_number}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles['branch-holder']}>
                      <span>{item.branch_name}</span>
                    </div>

                    <div className={styles['bank-label']}>NACH Details</div>

                    <div className={styles['table-responsive']}>
                      <table className={styles.table}>
                        <thead>
                          <tr>
                            <th>NACH Type</th>
                            <th>NACH Status</th>
                            <th>Vendor</th>
                            <th>Date</th>
                            <th>Actions</th>
                            <th>Notify</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bankNachData.length === 0
                            ? "No Data Found!"
                            : bankNachData.map((ndata, idx) => {
                                return item.bank_id === ndata.bank_id
                                  ? ndata.nach_data
                                      .map((nachdata, idx2) => {
                                      return (
                                        <tr key={idx2}>
                                          <td>
                                            {nachdata.nach_type_description}
                                          </td>
                                          <td>
                                            {
                                              nachdata.nach_status_type_description
                                            }
                                          </td>
                                          <td>
                                            {nachdata.payment_vendor_name[0]} |{" "}
                                            {nachdata.partner_code}
                                          </td>
                                          <td>{nachdata.added_at}</td>
                                          <td className={styles.align_items_center}>
                                            {nachdata.nach_status_type_flag ===
                                              "E" ||
                                            nachdata.nach_status_type_flag ===
                                              "J" ||
                                            nachdata.nach_status_type_flag ===
                                              "D" ||
                                            nachdata.nach_status_type_flag ===
                                              "R" ? (
                                              "NA"
                                            ) : nachdata.nach_type === "P" ? (
                                              nachdata.signed_filename ==
                                                null ||
                                              nachdata.signed_filename ===
                                                "null" ||
                                              nachdata.signed_filename ===
                                                "" ? (
                                                <div className={styles.updownimg_action}>
                                                  <div className={styles.updownimg} >
                                                    <img
                                                      src={require("../assets/images/view-fin.png")}
                                                      className={styles['add-new']}
                                                      style={{width:"36px", height:"36px"}}
                                                      onClick={() => {
                                                        viewclick(
                                                          nachdata.filename
                                                        );
                                                      }}
                                                      alt="View Document"
                                                    />
                                                    <div
                                                      className={styles['upload-img']}
                                                      onClick={(event) => {
                                                        event.preventDefault();
                                                        const ref =
                                                          uploadRefs.current[
                                                            "upload" +
                                                              ndata.bank_id
                                                          ];
                                                        if (ref) ref.click();
                                                      }}
                                                    >
                                                      <img
                                                        src={require("../assets/images/upload.png")}
                                                        className={styles['add-new']}
                                                        style={{width:"36px", height:"36px"}}
                                                        alt="Upload File"
                                                      />
                                                    </div>
                                                    <input
                                                      type="file"
                                                      name="file"
                                                      accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
                                                      onChange={(event) => {
                                                        event.preventDefault();
                                                        setIsSpin(false);
                                                        ImgchangeHandler(
                                                          event,
                                                          ndata.bank_id,
                                                          nachdata.physical_nach_order_id,
                                                          nachdata.partner_vendor_payment_account_id
                                                        );
                                                      }}
                                                      ref={(ref) => {
                                                        uploadRefs.current[
                                                          "upload" +
                                                            ndata.bank_id
                                                        ] = ref;
                                                      }}
                                                      style={{
                                                        display: "none",
                                                      }}
                                                    />
                                                    {(process.env.REACT_APP_effective_designation_id || "").split(
                                                      ","
                                                    ).includes(
                                                      effectiveDesignationId.toString()
                                                    ) &&
                                                    nachdata.nach_status_type_flag ===
                                                      "A" ? (
                                                      <button
                                                        className={`${styles.btn} ${styles['btn-danger']}`}
                                                        onClick={() =>
                                                          markExpire(
                                                            ndata.bank_id,
                                                            nachdata.third_reference_number_nach
                                                          )
                                                        }
                                                      >
                                                        Expire
                                                      </button>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                  <div className={styles.updownimg}>
                                                    <img
                                                      src={require("../assets/images/view-fin.png")}
                                                      className={styles['add-new']}
                                                      onClick={() => {
                                                        viewclick(
                                                          nachdata.signed_filename
                                                        );
                                                      }}
                                                      alt="View Signed Document"
                                                    />
                                                  </div>
                                                </>
                                              )
                                            ) : (
                                              "NA"
                                            )}
                                          </td>
                                          <td>
                                            {/* SMS/Email icons - Only show if NOT Physical NACH */}
                                            {nachdata.nach_type !== "P" && (() => {
                                              let invoiceId;
                                              
                                              if (nachdata.second_reference_number_nach && 
                                                  nachdata.second_reference_number_nach.startsWith('inv_')) {
                                                invoiceId = nachdata.second_reference_number_nach;
                                              }
                                              else if (nachdata.second_reference_number_nach && 
                                                       nachdata.second_reference_number_nach.startsWith('TXN')) {
                                                invoiceId = nachdata.second_reference_number_nach;
                                              }
                                              else {
                                                invoiceId = nachdata.second_reference_number_nach || 
                                                           nachdata.third_reference_number_nach || 
                                                           nachdata.first_reference_number_nach ||
                                                           nachdata.physical_nach_order_id;
                                              }
                                              
                                              const partnerId = nachdata.partner_vendor_payment_account_id;
                                              
                                              const hasValidInvoiceId = invoiceId && 
                                                                       (invoiceId.startsWith('inv_') || 
                                                                        invoiceId.startsWith('TXN'));
                                              
                                              const isValidStatus = nachdata.nach_status_type_description === "Issued" || 
                                                                   nachdata.nach_status_type_description === "Initiated";
                                              
                                              return hasValidInvoiceId && partnerId && isValidStatus ? (
                                                <div className={styles.updownimg}>
                                                  <img
                                                    src={require("../assets/images/comment.png")}
                                                    className={styles.smsicn}
                                                    title="Send SMS"
                                                    alt="SMS"
                                                    style={{ filter: 'invert(1)' }}
                                                    onClick={() =>
                                                      sendsmsmail(
                                                        invoiceId,
                                                        partnerId,
                                                        "sms"
                                                      )
                                                    }
                                                  />
                                                  <img
                                                    src={require("../assets/images/mail.png")}
                                                    className={styles.mailicn}
                                                    title="Send Email"
                                                    alt="Email"
                                                    style={{ filter: 'invert(1)' }}
                                                    onClick={() =>
                                                      sendsmsmail(
                                                        invoiceId,
                                                        partnerId,
                                                        "email"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ) : null;
                                            })()}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : "";
                              })}
                        </tbody>
                      </table>
                    </div>

                    <div className={`${styles['button-holder']} ${styles.row}`}>
                      <div className={`${styles['left-button']} ${styles['col-6']}`}>
                        <div className={styles.updownimg}>
                          <img
                            src={require("../assets/images/add-fin.png")}
                            className={styles['add-new']}
                            onClick={() => showNACHPopup(item)}
                            alt="Add New NACH"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
      </section>

      <ChatSupportBtn history={history} />
    </>
  );
};

export default NACH_Household_list;